var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgArrowDownSmall = props => /*#__PURE__*/React.createElement("svg", _extends({
  className: "arrow-down-svg",
  viewBox: "0 0 10 6",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd",
  transform: "translate(-3, -5)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#2A2E2E",
  className: "fill-color",
  d: "M4.70710678,5.29289322 C4.31658249,4.90236893 3.68341751,4.90236893 3.29289322,5.29289322 C2.90236893,5.68341751 2.90236893,6.31658249 3.29289322,6.70710678 L7.29289322,10.7071068 C7.68341751,11.0976311 8.31658249,11.0976311 8.70710678,10.7071068 L12.7071068,6.70710678 C13.0976311,6.31658249 13.0976311,5.68341751 12.7071068,5.29289322 C12.3165825,4.90236893 11.6834175,4.90236893 11.2928932,5.29289322 L8,8.58578644 L4.70710678,5.29289322 Z"
}))));
export default SvgArrowDownSmall;